const indicesDialogSx = theme => ({
	inputWrapper: {
		padding: theme.spacing(2),
	},
});

export default indicesDialogSx;
